import { render, staticRenderFns } from "./MoreSafeManager.vue?vue&type=template&id=597f3c14&scoped=true"
import script from "./MoreSafeManager.vue?vue&type=script&lang=ts"
export * from "./MoreSafeManager.vue?vue&type=script&lang=ts"
import style0 from "./MoreSafeManager.vue?vue&type=style&index=0&id=597f3c14&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "597f3c14",
  null
  
)

export default component.exports